import { render } from "./ReviewModify.vue?vue&type=template&id=796f8c28"
import script from "./ReviewModify.vue?vue&type=script&lang=js"
export * from "./ReviewModify.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__